function AffiliationSignUp(props) {
    return (
        <>TEST</>
    )
}

export default AffiliationSignUp